import { render } from "./SidebarLogo.vue?vue&type=template&id=1304ed8b&scoped=true"
import script from "./SidebarLogo.vue?vue&type=script&lang=ts"
export * from "./SidebarLogo.vue?vue&type=script&lang=ts"

import "./SidebarLogo.vue?vue&type=style&index=0&id=1304ed8b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1304ed8b"

export default script